export default __webpack_public_path__ + "static/media/enviroment.7f9af740.7f9af740.jpg";